import { updateDepartment } from '../../Api/ApiDepartments';
import { setSnackbar, getCache, setCache } from '@/helpers';
import { getRequest } from '@/System/Store/endpoints';

const state = {
    company: {},
    meta: {
        name: '',
        address: '',
        email: '',
        phone_number: '',
        logo: '',
        logo_blob: '',
        department_id: '',
        department_name: '',
        organization_number: '',
        website: '',
        industry: null,
        expiring_interval: 3,
        delay_notifications_date: null,
        inactivate_notification: 0,
    },
    industries: [],
    countries: [],
};

const mutations = {
    SET_UPDATE_META(state, obj) {
        const key = Object.keys(obj)[0];
        state.meta[key] = obj[key];
    },
    SET_SETTINGS(state) {
        const cache = getCache();
        const currentDepartment = cache?.currentDepartment;

        if (currentDepartment) {
            state.company = currentDepartment.company;
            state.meta.department_id = currentDepartment.id;
            state.meta.department_name = currentDepartment.name;
            state.meta.name = currentDepartment.certificate_meta?.name || currentDepartment?.company?.name || '';
            state.meta.address = currentDepartment.certificate_meta?.address || '';
            state.meta.email = currentDepartment.certificate_meta?.email || '';
            state.meta.logo = currentDepartment.certificate_meta?.logo || '';
            state.meta.phone_number = currentDepartment.certificate_meta?.phone_number || '';
            state.meta.website = currentDepartment.certificate_meta?.website || '';
            state.meta.industry = currentDepartment?.industry;
            state.meta.expiring_interval = currentDepartment?.expiring_interval;
            state.meta.delay_notifications_date = currentDepartment?.delay_notifications_date || null;
            state.meta.inactivate_notification = currentDepartment?.inactivate_notification == 1;
        }
    },
    SAVE_LOGOTYPE(state, path) {
        state.meta.logo = path;
        state.meta.logo_blob = '';
    },
    UPLOAD_FILE: (state, file) => (state.meta.logo_blob = file),
    UPLOAD_NEW_LOGO: (state) => (state.meta.logo = ''),
    SET_INDUSTRIES: (state, industries) => (state.industries = industries),
    SET_COUNTRIES: (state, countries) => (state.countries = countries),
};

const actions = {
    async UPDATE_DEPARTMENT({ state, commit, dispatch }) {
        const payload = new FormData();

        commit('GlobalStore/SET_SAVE_STATUS', 'pending', { root: true });

        payload.append('_method', 'PATCH');
        payload.append('name', state.meta.department_name);
        payload.append('certificate_meta[name]', state.meta.name);
        payload.append('certificate_meta[address]', state.meta.address);
        payload.append('certificate_meta[email]', state.meta.email);
        payload.append('certificate_meta[phone_number]', state.meta.phone_number);
        payload.append('certificate_meta[website]', state.meta.website);
        payload.append('expiring_interval', state.meta.expiring_interval || 3);
        payload.append('industry_id', state.meta.industry?.id);
        payload.append('delay_notifications_date', state.meta.delay_notifications_date);
        payload.append('inactivate_notification', state.meta.inactivate_notification ? 1 : 0);

        if (state.meta.logo_blob.length > 0) {
            const blob = await fetch(state.meta.logo_blob).then((res) => res.blob());
            payload.append('certificate_meta[logo]', blob);
        }

        await updateDepartment(payload).then((response) => {
            const snackbar = setSnackbar(response);
            const btnStatus = response.status;

            if (response.status === 'Success') {
                const cache = getCache();
                const key = cache.acceptedDepartments.findIndex((d) => d.id === response.data.id);
                if (key >= 0) {
                    cache.acceptedDepartments[key] = { ...response.data };
                }
                cache.currentDepartment.display_name = response.data.display_name;
                cache.currentDepartment.name = response.data.name;
                cache.currentDepartment.department = response.data.department;
                cache.currentDepartment.certificate_meta = { ...response.data.certificate_meta };
                cache.currentDepartment.expiring_interval = state.meta.expiring_interval || 3;
                cache.currentDepartment.inactivate_notification = response.data.inactivate_notification == 1;

                setCache(cache);

                commit('Departments/CHANGE_CURRENTDEPARTMENT', cache.currentDepartment, { root: true });
                commit('Departments/CHANGE_ACCEPTEDDEPARTMENT', cache.acceptedDepartments, { root: true });
                if (response.data.certificate_meta.logo) {
                    commit('SAVE_LOGOTYPE', response.data.certificate_meta.logo);
                }
            } else {
                dispatch('GlobalStore/SET_SNACKBAR', snackbar, { root: true });
            }

            commit('GlobalStore/SET_SAVE_STATUS', btnStatus, { root: true });
        });
    },
    async GET_INDUSTRIES({ commit }) {
        getRequest(route('industries')).then((response) => {
            if (response.status === 'Success') {
                commit('SET_INDUSTRIES', response.data);
            }
        });
    },
    async GET_COUNTRIES({ commit }) {
        getRequest(route('countries')).then((response) => {
            if (response.status === 'Success') {
                commit('SET_COUNTRIES', response.data);
            }
        });
    },
};

const getters = {
    GET_COUNTRIES: (state) => state.countries,
    GET_INDUSTRIES: (state) => state.industries,
    GET_COMPANY: (state) => state.company,
    GET_META: (state) => state.meta,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
